/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Manager_Buy_AddonInputs */

const en_domain_manager_buy_addon = /** @type {(inputs: Domain_Manager_Buy_AddonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy Domain Add-on`)
};

const es_domain_manager_buy_addon = /** @type {(inputs: Domain_Manager_Buy_AddonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprar Complemento de Dominio`)
};

const fr_domain_manager_buy_addon = /** @type {(inputs: Domain_Manager_Buy_AddonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acheter une extension de domaine`)
};

const de_domain_manager_buy_addon = /** @type {(inputs: Domain_Manager_Buy_AddonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain-Add-on kaufen`)
};

/** @type {(inputs: Domain_Manager_Buy_AddonInputs) => LocalizedString} */
const ja_domain_manager_buy_addon = en_domain_manager_buy_addon;

/** @type {(inputs: Domain_Manager_Buy_AddonInputs) => LocalizedString} */
const zh_domain_manager_buy_addon = en_domain_manager_buy_addon;

/** @type {(inputs: Domain_Manager_Buy_AddonInputs) => LocalizedString} */
const ar_domain_manager_buy_addon = en_domain_manager_buy_addon;

/** @type {(inputs: Domain_Manager_Buy_AddonInputs) => LocalizedString} */
const id_domain_manager_buy_addon = en_domain_manager_buy_addon;

/** @type {(inputs: Domain_Manager_Buy_AddonInputs) => LocalizedString} */
const it_domain_manager_buy_addon = en_domain_manager_buy_addon;

/** @type {(inputs: Domain_Manager_Buy_AddonInputs) => LocalizedString} */
const ru_domain_manager_buy_addon = en_domain_manager_buy_addon;

/** @type {(inputs: Domain_Manager_Buy_AddonInputs) => LocalizedString} */
const pt_domain_manager_buy_addon = en_domain_manager_buy_addon;

/** @type {(inputs: Domain_Manager_Buy_AddonInputs) => LocalizedString} */
const ko_domain_manager_buy_addon = en_domain_manager_buy_addon;

/**
* | output |
* | --- |
* | "Buy Domain Add-on" |
*
* @param {Domain_Manager_Buy_AddonInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_manager_buy_addon = /** @type {((inputs?: Domain_Manager_Buy_AddonInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Manager_Buy_AddonInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_manager_buy_addon(inputs)
	if (locale === "es") return es_domain_manager_buy_addon(inputs)
	if (locale === "fr") return fr_domain_manager_buy_addon(inputs)
	if (locale === "de") return de_domain_manager_buy_addon(inputs)
	if (locale === "ja") return ja_domain_manager_buy_addon(inputs)
	if (locale === "zh") return zh_domain_manager_buy_addon(inputs)
	if (locale === "ar") return ar_domain_manager_buy_addon(inputs)
	if (locale === "id") return id_domain_manager_buy_addon(inputs)
	if (locale === "it") return it_domain_manager_buy_addon(inputs)
	if (locale === "ru") return ru_domain_manager_buy_addon(inputs)
	if (locale === "pt") return pt_domain_manager_buy_addon(inputs)
	return ko_domain_manager_buy_addon(inputs)
});